import cx from 'classnames';
import React, { useState, useEffect } from 'react';
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { IoHomeOutline } from 'react-icons/io5'
import { LuComponent, LuTicket, LuUserCog } from 'react-icons/lu'
import { PiCertificate } from 'react-icons/pi'
import { CiViewTable } from 'react-icons/ci'
import { FiAlignJustify } from 'react-icons/fi'
import { jwtDecode } from "jwt-decode";
import {  CiUser } from "react-icons/ci";
import Modal from "react-bootstrap/Modal";

// groupName
import {
  Navbar,
  Nav,
  NavItem,
 /* Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,*/
} from 'reactstrap';
import {  useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { fetchAllDataApi, getLatestMessages, getUnseenNotifications } from '../../services/notifications';
import { CiLogout } from "react-icons/ci";
import { FaBell, FaCalendarAlt, FaClock, FaRegArrowAltCircleLeft, FaRegArrowAltCircleRight, FaRegBell, FaUser } from "react-icons/fa"; // For the Bell icon
import { seenNotification } from '../../services/notifications';
import PopoverNotification from './poppupNotification'; // Import the PopoverNotification component

import './Header.css';
import i18n, { changeLanguage } from '../../i18n';
import { IoSearchOutline } from 'react-icons/io5';
import { FiSearch } from 'react-icons/fi';
import { getInfouserById, getUserInfo } from 'src/services/userServicer';
import authService from '../../services/authService';
import SecureCookieManager from '../../utils/secureCookie';


interface Notification {
  id: number;
  message: string;
  functionsAll: string;
  createdAt: Date;
  seen: boolean;
}

interface HeaderProps {
  onMobileToggle: () => void
  toggleSidebar?: () => void
  className?: string
}

const Header: React.FC<HeaderProps> = ({ onMobileToggle, toggleSidebar, className }) => {
  const { t } = useTranslation();
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  //const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('en');
//  const [notifications, setNotifications] = useState([]);
 // const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [isNotiOpen, setIsNotiOpen] = useState(false); // State to control notification popup visibility
  const [unseenCount, setUnseenCount] = useState(0); // Initial dummy data
  const [latestNotification, setlatestNotification] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);
const [isLoading, setIsLoading] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
  const [userData, setUserData] = useState<any>(null);
  
const handleProfileClick = async () => {
  try {
    setIsLoading(true);
    setShowProfile(true);

    const user = await getUserInfo();  
    console.log(user)// أولاً نحصل على بيانات المستخدم
    if (!user?.id) {
      toast.error("User not found");
      setShowProfile(false);
      return;
    }

    const data = await getInfouserById(user.id); // نستخدم الـ id هنا
    setUserData(data);
  } catch (error) {
    console.error("Failed to fetch user info:", error);
    toast.error("Failed to load user profile");
    setShowProfile(false);
  } finally {
    setIsLoading(false);
  }
};


  // Dummy data for all notifications
 /* const [allNotification, setAllNotification] = useState<Notification[]>([
    { id: 1, message: 'Notification 1', functionsAll: 'Message', createdAt: new Date(), seen: false },
    { id: 2, message: 'Notification 2', functionsAll: 'Reminder', createdAt: new Date(), seen: true },
    { id: 3, message: 'Notification 3', functionsAll: 'System', createdAt: new Date(), seen: false },
  ]);*/

const links = [
  { 
    page: 'dashboard', 
    labelKey: 'Sidebar.Home', 
    href: '/', 
    icon: (props: any) => <IoHomeOutline {...props} /> 
  },
  { 
    page: 'standards', 
    labelKey: 'Sidebar.Reference', 
    href: '/standards', 
    icon: (props: any) => <CiViewTable {...props} />
  },
  { 
    page: 'compliances', 
    labelKey: 'Sidebar.Compliance', 
    href: '/compliances', 
    icon: (props: any) => <LuComponent {...props} />
  },
  { 
    page: 'tickets', 
    labelKey: 'Sidebar.Tickets', 
    href: '/ticket', 
    icon: (props: any) => <LuTicket {...props} />
  },
  { 
    page: 'users', 
    labelKey: 'Sidebar.UserManagement', 
    href: '/user', 
    icon: (props: any) => <LuUserCog {...props} />
  },
  { 
    page: 'certifications', 
    labelKey: 'Sidebar.Certifications', 
    href: '/certifications', 
    icon: (props: any) => <PiCertificate {...props} />
  },
];

  // Function to mark notifications as seen
  const seeNotification = async () => {
    try {
      const user = await getUserInfo();
      if (!user?.id) return;
      let userId =  user.id || "";
      await seenNotification(userId);
      setUnseenCount(0);
      setIsNotiOpen(false); // Close the notification popup
    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };

  // Toggle language dropdown
  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };
  const toggleMobileSearch = () => {
    setIsMobileSearchVisible(!isMobileSearchVisible);
  };
  // Handle logout - same as new_demo_frontend
  const handleLogout = async () => {
    try {
      // Call backend logout (calls /auth/force-logout like new_demo_frontend)
      const responseData = await authService.logout();
      
      // Clear cookies and storage (same as new_demo_frontend)
      const { clearV2Token, getCookieDomain } = await import('../../utils/v2AuthUtils');
      // Use the same domain detection logic as new_demo_frontend
      const domain = getCookieDomain();
      clearV2Token(domain);
      
      // Clear front_compliance cookies
      SecureCookieManager.clearAuthCookies();
      
      // Clear storage (same as new_demo_frontend)
      localStorage.clear();
      
      // Show success message if logout was successful
      if (responseData?.success) {
        toast.success('User logged out successfully');
      } else {
        toast.error('You logged out but session is still active. Contact admin.');
      }
      
      // Redirect to login
      navigate('/login');
    } catch (error: any) {
      console.error('Logout error:', error);
      // Even if logout fails, clear everything and redirect (same as new_demo_frontend)
      const { clearV2Token, getCookieDomain } = await import('../../utils/v2AuthUtils');
      // Use the same domain detection logic as new_demo_frontend
      const domain = getCookieDomain();
      clearV2Token(domain);
      SecureCookieManager.clearAuthCookies();
      localStorage.clear();
      toast.error('You logged out but session is still active. Contact admin.');
      navigate('/login');
    }
  };

  // Fetch notifications (dummy implementation)
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const user = await getUserInfo();
        if (!user?.id) return;
        let userId =  user.id || "";
        const total_count = await fetchAllDataApi(`notifications/unseen?userId=${userId}&query=${""}&perPage=${5}&pageNo=${0}`);
        const latestMessages = await getLatestMessages(`notifications/notifications-latest`);
        setlatestNotification(latestMessages?.data)
       // setTotalCount(total_count?.totalCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchNotifications();
    getUnseenNotificationsData()
  }, []);

  const getUnseenNotificationsData = async () => {
    const user = await getUserInfo();
    if (!user?.id) return;
    let userId =  user.id || "";
    const unseenNotifications = await getUnseenNotifications(userId);
    if(unseenNotifications.success){
    setUnseenCount(unseenNotifications.totalCount);
    }
    else{
      setUnseenCount(0);
    }
  };

  /*useEffect(() => {
    const socket = getWebSocket();

    if (socket) {
      socket.on('receiveNotification', (notification:any) => {
        // Option 1: Increment the unseen count
       // console.log('notification', notification)
        setUnseenCount((prevCount) => prevCount + 1);
        getUnseenNotificationsData()
        // Option 2: Fetch notifications again
        // fetchNotifications();
      });
    }

    return () => {
      if (socket) {
        socket.off('receiveNotification'); // Clean up the event listener
      }
    };
  }, []);*/

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    // Use the changeLanguage function from i18n which includes sync functionality
    changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
  };

  return (
    <Navbar className="root-header">
      {/* Sidebar toggle button (Visible only on md and up) */}
      <button 
        className="btn sidebar-toggle d-none d-md-flex" 
        onClick={onMobileToggle}
        aria-label={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
      >
        {isSidebarOpen ? (
          <FaRegArrowAltCircleLeft size={24} />
        ) : (
          <FaRegArrowAltCircleRight size={24} />
        )}
      </button>
  
      {/* Mobile navigation dropdown without toggle button */}
      <div className="d-flex d-md-none align-items-center">
        <Dropdown>
          <Dropdown.Toggle 
            variant="link" 
            id="mobile-nav-dropdown"
            className="mobile-menu-button"
          >
            <span className="navbar-toggler-icon"></span>
          </Dropdown.Toggle>
  
          <Dropdown.Menu className="mobile-nav-menu">
            {links.map((link) => (
              <Dropdown.Item 
                key={link.href}
                onClick={() => {
                  navigate(link.href);
                  setIsMobileNavOpen(false);
                }}
                className="mobile-nav-item"
              >
                <div className="d-flex align-items-center">
                  {React.createElement(link.icon, { className: "me-2" })} {t(link.labelKey)}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
  
      {/* Search bar */}
      <div className={`search-container ${isMobileSearchVisible ? 'mobile-visible' : ''}`}>
        <Nav className="w-100">
          <NavItem className="w-75">
            <div className="inputSearch">
              <input
                type="text"
                placeholder={t('header.Search ....') || ''}
                className="form-control w-100 p-2 ps-4 bg-gray-100"
              />
            </div>
          </NavItem>
        </Nav>
      </div>
  
      {/* Mobile search toggle button */}
      <button 
        className="btn mobile-search-toggle d-md-none"
        onClick={toggleMobileSearch}
      >
        <FiSearch size={20} />
      </button>
  
      {/* Right side elements */}
      <div className="header-right-elements">
        {/* Notification */}
        <div className="notification-wrapper">
          <FaRegBell
            color="gray"
            size={20}
            className="hover-scale-110 cursor-pointer transition mt-2"
            onClick={() => setIsNotiOpen((s) => !s)}
          />
          {unseenCount > 0 && (
            <span className="notification-badge bg-danger pt-1">
              {unseenCount}
            </span>
          )}
          <PopoverNotification
            isOpen={isNotiOpen}
            onClose={() => setIsNotiOpen(false)}
            updateNotifications={seeNotification}
            notifications={latestNotification}
          />
        </div>
  
        {/* Language selector */}
        <button
          className="lang-switch d-flex align-items-center bg-transparent border-0 p-0"
          onClick={toggleLanguage}
        >
          <div className="language-flag">
            <img
              src={`/assets/images/${currentLanguage}.jpg`}
              alt={currentLanguage}
            />
          </div>
          <span className="d-none px-2 d-sm-inline">
            {currentLanguage === 'en' ? t('header.english') : t('header.arabic')}
          </span>
        </button>
  
        {/* Divider */}
        <div className="header-divider"></div>
  
        {/* Profile dropdown */}
        <Dropdown align="end" className="profile-dropdown">
          <Dropdown.Toggle as="div" className="profile-toggle">
            <img
              className="admin-photo mx-2"
              src="/assets/images/profile.png"
              alt="administrator"
            />
          </Dropdown.Toggle>
          
      <Dropdown.Menu>
        <Dropdown.Item onClick={handleProfileClick} className="logout-item">
          <CiUser className="logout-icon" />
          <span>My Profile</span>
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Item onClick={handleLogout} className="logout-item">
          <CiLogout className="logout-icon" />
          <span>Logout</span>
        </Dropdown.Item>
      </Dropdown.Menu>

        <Modal show={showProfile} onHide={() => setShowProfile(false)} centered dialogClassName="modal">
  <Modal.Header closeButton className="bg-light" dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}>
    <Modal.Title className="w-100 text-center">
      <FaUser className="text-primary mb-2" size={64} />
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {isLoading ? (
      <div className="text-center py-4">
        <span className="spinner-border text-primary" role="status"></span>
        <p className="mt-2">{t("header.Loading")}...</p>
      </div>
    ) : userData ? (
      <div className="text-center">
        {/* Name */}
        <h4 className="fw-bold">{userData.name}</h4>
        <p className="text-muted">{userData.email}</p>

        {/* Group badge */}
        <span className="badge bg-warning text-dark px-3 py-2 mb-4 rounded-pill">
          {userData.group?.name || t("header.Group")}
        </span>

        {/* User Info */}
        <div className="text-start px-4">
          <div className="mb-3 d-flex align-items-center">
            <FaUser className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Username")}:</strong> {userData.username}
          </div>
          <div className="mb-3 d-flex align-items-center">
            <FaClock className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Last Login")}:</strong> {userData.lastLogin || ""}
          </div>
          <div className="mb-3 d-flex align-items-center">
            <FaCalendarAlt className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Created At")}:</strong> {new Date(userData.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>
    ) : (
      <div className="text-danger text-center">
        <p>{t("header.Failed to load profile data")}</p>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowProfile(false)}>
      {t("header.Close")}
    </Button>
  </Modal.Footer>
</Modal>

        </Dropdown>
      </div>
    </Navbar>
  );
  
}

export default Header;